import { Box, Grid2, Tooltip } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { Fragment } from 'react/jsx-runtime';
import { ReactComponent as WhiteScene3dIcon } from '../../../../assets/icons/scene-3d-icon-white.svg';
import { ReactComponent as ShareIcon } from '../../../../assets/icons/share-icon.svg';
import { openDialog } from '../../../../store/dialog/dialog.action';
import { DIALOG_TYPES } from '../../../../store/dialog/dialog.types';
import { selectNodeSelected } from '../../../../store/node/node.selector';
import { getDateScene, getUserScene } from '../../../../utils/data/data.utils';
import {
    CustomAccordionDetailsGridText,
    CustomAccordionDetailsTitleText,
} from '../node-accordion-details.styles';

const NodeAccordionDetailsScenes3dGrid = () => {
    const nodeSelected = useSelector(selectNodeSelected);

    const dispatch = useDispatch();

    const handleShareButtonClick = (sceneId: number) => {
        dispatch(
            openDialog(DIALOG_TYPES.SHARE_SCENE_3D, { sceneId: sceneId }, 'xs')
        );
    };

    return (
        <Fragment>
            <CustomAccordionDetailsTitleText height={40}>
                {`SCENE 3D`}
            </CustomAccordionDetailsTitleText>
            <Box my={2} />
            {nodeSelected &&
                nodeSelected.scenes_3d.map((s) => {
                    return (
                        <Grid2
                            container
                            height={40}
                            key={s.id}
                            alignItems={'center'}
                        >
                            <Grid2 container size={4} gap={1}>
                                <Grid2
                                    size={1}
                                    container
                                    justifyContent={'end'}
                                    alignItems={'center'}
                                >
                                    <WhiteScene3dIcon />
                                </Grid2>
                                <Grid2 size={7} container alignItems={'center'}>
                                    <Tooltip title={s.name}>
                                        <CustomAccordionDetailsGridText>
                                            {s.name}
                                        </CustomAccordionDetailsGridText>
                                    </Tooltip>
                                </Grid2>
                                <Grid2 container alignItems={'center'}>
                                    <Tooltip title={'Condividi'}>
                                        <ShareIcon
                                            cursor={'pointer'}
                                            onClick={() =>
                                                handleShareButtonClick(s.id)
                                            }
                                        />
                                    </Tooltip>
                                </Grid2>
                            </Grid2>
                            <Grid2 size={3} container>
                                <Grid2 size={12} alignContent={'center'}>
                                    <CustomAccordionDetailsGridText>
                                        {getDateScene(s)}
                                    </CustomAccordionDetailsGridText>
                                </Grid2>
                            </Grid2>
                            <Grid2 size={3} container alignItems={'center'}>
                                <CustomAccordionDetailsGridText>
                                    {getUserScene(s)}
                                </CustomAccordionDetailsGridText>
                            </Grid2>
                        </Grid2>
                    );
                })}
        </Fragment>
    );
};

export default NodeAccordionDetailsScenes3dGrid;
